var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1678 18.181C11.931 18.181 13.5773 17.6128 14.9156 16.666L19.9501 21.6528C20.1838 21.8843 20.4918 22 20.8104 22C21.5008 22 22 21.474 22 20.8006C22 20.485 21.8938 20.1904 21.6601 19.959L16.6575 14.9932C17.709 13.6255 18.3356 11.9316 18.3356 10.0905C18.3356 5.64019 14.6606 2 10.1678 2C5.66437 2 2 5.64019 2 10.0905C2 14.5408 5.66437 18.181 10.1678 18.181ZM10.1678 16.4345C6.65215 16.4345 3.76314 13.5623 3.76314 10.0905C3.76314 6.61862 6.65215 3.74645 10.1678 3.74645C13.6729 3.74645 16.5725 6.61862 16.5725 10.0905C16.5725 13.5623 13.6729 16.4345 10.1678 16.4345Z",
    fill: "#8E8E93"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.b97aa1a4b27b193bc80acbcce6a68733.svg";
export { ForwardRef as ReactComponent };